import { z } from 'zod';

export const DeliveryArticleRecommendationModelSchema = z.object({
    uid: z.string(),
    name: z.string(),
    weight: z.number().optional().nullable(),
    price: z.number().optional().nullable(),
    image: z.object({
        url: z.string(),
    }).optional().nullable(),
    currency: z.object({
        name: z.string(),
        abbreviation: z.string(),
    }).optional().nullable(),
});

export type DeliveryArticleRecommendationModel
= z.infer<typeof DeliveryArticleRecommendationModelSchema>;
